module.exports = __webpack_public_path__ + "img/zuijia_12.dca21e9f.png";